import {KDSCapableOrderProcessorData, KvdDisplayType} from "../order_processor/order-processor.data";
import {field, transientField} from "@fedeltapointofsale/data-client";

export class DocketPrintingRuleData extends KDSCapableOrderProcessorData<DocketPrintingRuleData> {
    @field printQueueSize: boolean = false;
    @field kvdDocketQueueTestMode: boolean = false;
    @field kvdDocketQueueOpenModeLimit: number = 10;
    @field kvdDocketQueueOpenModeResetMinutes: number = 30;
    @field kvdDocketQueueAutoRateDockets: number = 5;
    @field kvdDocketQueueAutoRateMinutes: number = 10;
    @field kvdDocketQueueBlockMinutes: number = 5;

    @transientField get useKvdDocketQueue(): boolean {
        return this.kvdDisplayType === KvdDisplayType.DOCKET_QUEUE;
    }

    set useKvdDocketQueue(useKvdQueue: boolean) {
        this.kvdDisplayType = useKvdQueue ? KvdDisplayType.DOCKET_QUEUE : null;
    }
}
